import { useMediaQuery } from './useMediaQuery'

/**
 * useIsMobile — 与 Tailwind `lg` 断点对齐 (1024px)
 * 项目内 < lg 视为移动端，≥ lg 视为桌面端
 */
export function useIsMobile() {
  return useMediaQuery('(max-width: 1023.98px)')
}

export default useIsMobile
